/** Read every page, including empty filtered pages that still have a cursor. */
export async function collectPages<T>(load: (cursor?: string) => Promise<{ items: T[]; cursor?: string }>, initialCursor?: string): Promise<T[]> {
  const items: T[] = [];
  const seen = new Set<string>();
  let cursor = initialCursor;
  do {
    if (cursor) {
      if (seen.has(cursor)) throw new Error('Pagination cursor did not advance.');
      seen.add(cursor);
    }
    const page = await load(cursor);
    items.push(...page.items);
    cursor = page.cursor;
  } while (cursor);
  return items;
}
